import { html } from 'lit-element';
import aspect from '../common/aspect';

export default function loader() {
  return function decorator(target) {
    Object.assign(target.prototype, {
      __$loaderCount: 0,

      promiseLoader(p) {
        this.__$loaderCount += 1;
        this.requestUpdate();
        return p.finally(() => {
          this.__$loaderCount -= 1;
          this.requestUpdate();
        });
      },

      // default loader
      _renderLoader() {
        if (this.loading) {
          return html`
            <style>
              .spiner-wrapper {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 99;
              }
              paper-spinner {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            </style>
            <div class="spiner-wrapper"><paper-spinner active></paper-spinner></div>
          `;
        }
        return '';
      },
    });

    Object.defineProperty(target.prototype, 'loading', {
      get() {
        return this.__$loaderCount > 0;
      },
    });

    aspect(target.prototype, 'render', origin => {
      return function () {
        return html`${this._renderLoader()}${origin.apply(this)}`;
      };
    });
  };
}
